import { filter } from "lodash";

import { v4 as UUID } from "uuid";
import { decryptData, encryptData } from "~/Utils/hasher";
import { useSessionStorage } from "./useSessionStorage";

export const useMaskId = () => {
  const [idMap, setIdMap] = useSessionStorage("idMap", []);

  const mask = (id: string, category: string) => {
    const maskedId = UUID();
    const existing = filter(idMap, (value: any) => value.realId == id);
    if (existing.length === 0) {
      setIdMap([
        ...idMap,
        {
          realId: encryptData(id),
          maskedId,
          category,
        },
      ]);
      return maskedId;
    } else {
      return existing[0].maskedId;
    }
  };

  const unmask = (maskedId: string) => {
    const existing = filter(idMap, (value: any) => value.maskedId == maskedId);
    if (existing.length > 0) {
      return decryptData(existing[0].realId);
    } else {
      return maskedId;
    }
  };

  const clearMaskedIDs = (category: string) => {
    setIdMap(filter(idMap, (value: any) => value.category !== category));
  };

  return {
    mask,
    unmask,
    clearMaskedIDs,
  };
};
